module.exports = __webpack_public_path__ + "img/RDOGE.0d315991.png";